import LoadingPage from "./pages/loading";

function App() {
  window.location.href = "/firetwrks";
  return <LoadingPage />;
}

export default App;
